module.exports={
    "index": {
        "login": "회원 순위",
        "regist": "신규 사용자를 위한 선물",
        "user": "새로운 팀",
        "jiang": "회원",
        "set": "주목",
        "lingqyu": "입력된 비고가 없습니다 . 설정해 주세요.",
        "liji": "입력되지 않았습니다 . 설정해 주세요.",
        "list": {
            "0": "입금시간",
            "1": "직불카드 정보",
            "2": "참고 : 비트코인 지갑과 USDT 지갑이 충전됩니다. 충전원금의 10% + 수수료 USD 20 무료",
            "3": "못받아서 죄송해요 계속 구매해주세요",
            "4": "달러",
            "5": "첫날 주문량이 20개에 도달하여 더 이상 주문할 수 없습니다.",
            "6": "지금 제출"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "은행 계좌",
                "1": "주문 취소"
            },
            "tianjia": {
                "0": "주소",
                "1": "주소가 입력되지 않았습니다 . 설정해 주세요."
            },
            "tiqu": {
                "0": "들어 오세요",
                "1": "계정 잔액이 200 미만입니다. 주문하기 전에 재충전하세요."
            }
        },
        "guanyu": {
            "title1": "계좌 잔액을 확인해주세요",
            "text1": "사용 가능한 계정 잔액이 부족합니다.",
            "title2": "주문이 처리되었습니다 . 페이지를 새로고침하세요.",
            "text2": "매개변수 오류입니다 . 주문 번호를 확인하세요."
        },
        "title_content": {
            "0": "주문번호가 존재하지 않습니다",
            "1": "주문을 받지 못했습니다 . 이 카테고리의 가격대에는 재고가 부족합니다.",
            "2": "주문을 가져오지 못했습니다 . 나중에 다시 시도해 주세요."
        },
        "content": {
            "0": "주문을 성공적으로 받았습니다",
            "1": "주문 잔액 이 부족합니다. 다시 주문해 주세요.",
            "2": "그것을 잡아"
        },
        "dugengduo": "회원등급 잔액 부족",
        "darkgrey": {
            "1": {
                "title": "주문 접수가 종료되었습니다",
                "text": "제 시간에 확인하다"
            },
            "2": {
                "title": "빨간 봉투를 받아라",
                "text": "재충전하러 가기"
            },
            "3": {
                "title": "다시 봐",
                "text": "잠금을 해제하려면 계정 잔액이 200 보다 커야 합니다."
            },
            "4": {
                "title": "다음 단계",
                "text": "확인 코드"
            },
            "5": {
                "title": "인증번호를 입력해주세요",
                "text": "그래픽 인증 코드 확인에 실패했습니다 . 다시 입력해 주세요."
            },
            "6": {
                "title": "요청 성공",
                "text": "휴대폰 번호 형식이 올바르지 않습니다."
            }
        },
        "into": {
            "yibiaoban": "계정이 존재하지 않습니다",
            "nihao": "사용자가 존재하지 않습니다",
            "yue": "사용자가 비활성화되었습니다.",
            "shebeigong": "이 계정은 이미 다른 곳에 로그인되어 있습니다.",
            "riqi": "비밀번호를 연속으로 너무 많이 잘못 입력했습니다.",
            "gaishu": "몇 분 후에 다시 시도하세요",
            "kaicaizong": "잘못된 비밀번호",
            "xiaoshili": "성공적으로 로그인하세요",
            "rili": "인증코드가 존재하지 않습니다",
            "zhouli": "인증코드 오류",
            "yeli": "인증 코드가 잘못되었습니다.",
            "tuilian": "초대코드가 존재하지 않습니다",
            "hezuo": "추천 사용자가 비활성화되었습니다",
            "fukuanxin": "잘못된 요청",
            "tianjiadi": "먼저 로그인을 해주세요",
            "gengxin": "이 계정은 비활성화되었습니다",
            "yibiaoti": "이 계정의 거래 기능이 정지되었습니다",
            "yaoqing": "이 계정에는 완료되지 않은 주문이 있어 더 이상 주문을 받을 수 없습니다.",
            "yaoqingren": "잔액이 다음보다 적습니다.",
            "shijian": "거래를 계속할 수 없습니다",
            "choujiangci": "회원 등급에 비해 거래 건수가 부족합니다.",
            "choujianggai": "관심 보물",
            "tuijianren": "만료 전 조기 출금 , 수익 없음, 수수료는",
            "xiejie": "본 상품의 최소 투자 금액",
            "jiriqi": "본 상품의 최대 투자금액",
            "dianjifu": "데이터 이상",
            "tishi": {
                "1": "사용 가능한 잔액이 부족합니다.",
                "2": "성공적인 운영",
                "3": "작업이 실패했습니다 . 계정 잔액을 확인하세요."
            },
            "chongzhijin": "투자 시작",
            "chongzhigai": "작동하다",
            "nindeyu": "이자 잔액 이체",
            "mianchong": "반복 작업",
            "mianchongci": "이자잔액 이체",
            "chongzhili": {
                "title": "매개변수 오류",
                "jine": "금지된",
                "shijian": "해당 기간 외에 현재 작업을 수행합니다.",
                "zhauntai": "재충전 금액은 다음보다 작을 수 없습니다."
            },
            "yijiangli": "재충전은 다음보다 클 수 없습니다.",
            "yiqizhuan": "이미지 형식 오류",
            "jianglili": "제출에 실패했습니다 . 나중에 다시 시도해 주세요.",
            "shezhi": "위챗페이",
            "mimashe": "알리페이로 결제",
            "dangqianmishu": "위챗 현금 인출",
            "xinmi": "알리페이 현금인출",
            "shuxinmi": "아직 추가된 은행 카드 정보가 없습니다.",
            "quemi": "거래 비밀번호가 설정되지 않았습니다.",
            "shuquemi": "회원 등급 탈퇴 한도는",
            "dainyou": "현재 등급 출금을 완료해야 합니다.",
            "dianyoudi": "명령",
            "shudainyou": "잔액 불충분",
            "fukuanshe": "금일 회원등급 출금횟수가 부족합니다.",
            "bitedi": "계좌 소유자의 이름이 필요합니다",
            "shugukuan": "계정 소유자 이름의 최대 길이는 30자입니다.",
            "jisheng": "은행 이름은 필수 항목입니다.",
            "qiangou": "은행 카드 번호가 필요합니다",
            "xiacixiaoshi": "휴대폰 번호가 필요합니다",
            "yingjian": "은행 카드 번호가 이미 존재합니다.",
            "zonggong": "작업 실패",
            "maidian": "페이지가 존재하지 않습니다",
            "yingjiancheng": "리베이트 받기",
            "zhuanzhang": "로그인되지 않은 사용자",
            "dianfeizong": "다시 제출하지 마세요.",
            "zhuanzhangti": "성공하다",
            "zhaunzhangfeiyong": "실패하다",
            "zuidifei": "성공",
            "tikuanjin": "이 이름과 은행 카드가 다른 계좌에 연결되어 있습니다.",
            "zuidixian": "기본 배송 주소를 삭제할 수 없습니다.",
            "bijieshou": "잘못된 로그인 비밀번호",
            "quezhi": "오늘 로그인했습니다",
            "querenti": "성공적으로 로그인 하고 빨간 봉투를 받으세요",
            "yiwen": "로그인이 완료되었습니다.",
            "tili": "모든 출금 주문",
            "yaohaoyou": "확인 통과",
            "yaohuoci": "주문을 받으려면 로그인하세요.",
            "yihanwei": "주문을 가져오지 못했습니다 . 나중에 다시 시도해 주세요.",
            "gongxihuo": "주문 접수 실패 , 제품 재고 부족"
        },
        "taocan": {
            "title": "휴대폰번호가 등록되었습니다",
            "text": "1분 이내에 문자 메시지는 1개만 보낼 수 있습니다.",
            "kuanggong": "성공적으로 보냈습니다",
            "liliang": "보내지 못했습니다.",
            "jiage": "SMS가 성공적으로 전송되었습니다.",
            "yingli": "불완전한 매개변수"
        },
        "baoming": {
            "title": "서버 공간이 지원되지 않습니다 . 컬이나 fsocket을 지원하는지 확인하세요. 문제를 해결하거나 공간을 변경하려면 공간 공급자에게 문의하세요.",
            "text": "계정이 만료되었습니다"
        }
    },
    "login": {
        "yongdeng": "IP 주소 제한",
        "quedeng": "콘텐츠에 민감한 단어가 포함되어 있습니다.",
        "yonghu": "제품 매개변수 이상",
        "mima": "사용 가능한 잔액이 부족합니다 . 먼저 충전하세요.",
        "xieyi": "오늘의 금액",
        "tiaokaun": "오늘의 사용자 수",
        "tongyi": "오늘 온라인에 접속한 사람 수",
        "wangmi": "년도",
        "zhaomi": "달",
        "zhaomiti": "로그인",
        "feihuiyuan": "마디 없는",
        "lizhi": "오늘 로그인하고 빨간 봉투 1개를 받았습니다.",
        "chaunghu": "낮",
        "yonghumming": "하나",
        "mimafu": "둘",
        "zhanghaoyou": "4개",
        "jinggao": "다섯"
    },
    "botton": {
        "lianjie": {
            "0": "육",
            "1": "로그인됨",
            "2": "오늘 이미 로그인했습니다.",
            "3": "다른 곳으로 이전하다"
        },
        "zhichi": {
            "0": "편입",
            "1": "쇼핑 센터"
        }
    },
    "content": {
        "zhichu": "하나",
        "jiage": "이류",
        "yinliang": "비허가",
        "jiaoyizhe": "설정 메시지",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "하루에 하나의 계정을 얻을 수 있습니다",
        "choujiang": "생성 커미션",
        "jiangli": "레벨 1",
        "chongzhi": "3세대 커미션",
        "zhuanzhang": "레벨 3",
        "yongjin": "결제 스크린샷 업로드",
        "lijikaishi": "새로고침하려면 위로 당겨주세요",
        "mianfei": "다음 단계의 독점 채널은 더 높은 수수료를 받을 수 있습니다.",
        "kaishi": "아래로 당겨 다시 정렬하세요.",
        "lianjie": "하위 커미션 리베이트",
        "zhoumo": "비워둘 수 없습니다.",
        "shizhi": "헌신적인 고객 서비스",
        "jiaoyi": "두 번 입력한 비밀번호가 일치하지 않습니다.",
        "zhichi": "두 번 입력한 펀드 비밀번호가 일치하지 않습니다.",
        "fuzhi": "개인 정보",
        "dangqian": "주문 매칭 등 플랫폼 감독을 방지하기 위해",
        "wanshan": "거래 비밀번호를 확인해 주세요.",
        "buyizhi": "구매자의 메시지",
        "ziyou": "배우다",
        "mai": "2세대 커미션",
        "yaoqing": "2 단계",
        "yihan": "QR 코드",
        "gongxi": "거래 비밀번호 관리",
        "huifu": "상세 거래 내역"
    },
    "tanchuang": {
        "one": "오늘 접수된 주문 수",
        "two": "오늘 이미 커미션 받았습니다",
        "title1": "오늘의 결과",
        "title2": "오늘의 수입"
    },
    "weishangxian": {
        "weishangxian": "위의 작업이 완료된 후 고객센터로 문의하여 점수를 업그레이드 해주세요.",
        "yueshouru": "가격",
        "meiyuan": "추가 작업",
        "qianggouzhong": "선교 홀",
        "chongzhidizhi": "작업 리베이트",
        "jine": "쿠폰",
        "bufu": "회원 자격은 영원히 유효합니다.",
        "zhengque": "회원 등급",
        "xuanxiang": "회원정보",
        "chongzhi": "Yu'e Bao 입출금 기록",
        "xiaoshi": "Yu'e Bao 수입",
        "yongjiu": "Yu'e Bao 환승",
        "yongjin": "Yu'e Bao 전학",
        "renshu": "유에 바오",
        "hezuo": "잔액 지불",
        "fenxiang": "잔액 이체",
        "chenggong": "균형",
        "tuijianID": "안녕하십니까 , 귀하의 권익 보호를 위해 4대 은행(중국은행, 건설, 공상, 농업)의 정확한 카드번호와 지점정보를 연결해 주시기 바랍니다. 정보를 잘못 입력하여 계좌를 등록할 수 없습니다. 이 플랫폼은 어떠한 책임도 지지 않습니다! 본 플랫폼은 4대 은행 이외의 은행에서는 현금 인출을 지원하지 않습니다.",
        "neirong": "커미션 플러스",
        "tuijian": "수수료율"
    },
    "into_one": {
        "yibiaoban": "수수료",
        "nihao": "QR 코드를 로컬 스캔 코드에 저장",
        "yue": "성공적으로 저장 되었음",
        "shebeigong": "스크린샷을 저장 하고 QR 코드를 스캔하여 결제하세요.",
        "riqi": "정보발표",
        "gaishu": "이름 수정",
        "kaicaizong": "비밀번호 변경",
        "xiaoshili": "수정되었습니다.",
        "rili": "원",
        "zhouli": "충전재",
        "yeli": "충전 중입니다 . 나중에 잔액을 새로고침하세요.",
        "tuilian": "재충전 및 업그레이드",
        "hezuo": "재충전 상태",
        "fukuanxin": "잠금 해제하려면 업그레이드하세요.",
        "tianjiadi": "잠금 해제하려면 재충전하세요.",
        "gengxin": "충전 주문 보류 중인 결제",
        "yibiaoti": "충전기록",
        "yaoqing": "재충전 지침",
        "yaoqingren": "충전 문의는 고객센터로 연락주세요",
        "shijian": "충전금액",
        "choujiangci": "충전하다",
        "choujianggai": "재충전 .",
        "tuijianren": "무료 등록",
        "xiejie": "우리는 주문을 받기 위해 열심히 노력하고 있으며 결과는 아래에 공개됩니다.",
        "jiriqi": "모든 상품",
        "dianjifu": "모두 철회",
        "tishi": {
            "1": "모두",
            "2": "동결",
            "3": "몇 분 내에 제출이 확인되지 않으면 시스템에서 주문 금액을 동결합니다."
        },
        "chongzhijin": "가리키다",
        "chongzhigai": "삭제",
        "nindeyu": "도착시간 : 5분",
        "mianchong": "남은 사용 가능한 자산",
        "mianchongci": "로드 중",
        "chongzhili": {
            "title": "업데이트 성공",
            "jine": "업로드로 이동",
            "shijian": "가서 주문 받아",
            "zhauntai": "추가하러 가기"
        },
        "yijiangli": "인증 코드 보내기",
        "yiqizhuan": "취소",
        "jianglili": "사용 가능한 잔액",
        "shezhi": "사용 가능한 잔액",
        "mimashe": "조약",
        "dangqianmishu": "협력",
        "xinmi": "이름",
        "shuxinmi": "다음 시간 이후에 시간 초과 상태를 입력하세요.",
        "quemi": "상품",
        "shuquemi": "몰 홈페이지",
        "dainyou": "홈페이지로 돌아가기",
        "dianyoudi": "팀 규모",
        "shudainyou": "팀 밸런스",
        "fukuanshe": "팀 커미션 상태",
        "bitedi": "팀 총 커미션",
        "shugukuan": "총 팀 재충전",
        "jisheng": "팀 전체 탈퇴",
        "qiangou": "팀 주문 커미션",
        "xiacixiaoshi": "팀 보고서",
        "yingjian": "팀 흐름",
        "zonggong": "팀 관리",
        "maidian": "팀",
        "yingjiancheng": "브라우저에서 열려",
        "zhuanzhang": "온라인 결제",
        "dianfeizong": "영역",
        "zhuanzhangti": "성공적으로 복사되었습니다",
        "zhaunzhangfeiyong": "링크 복사",
        "zuidifei": "클론",
        "tikuanjin": "하늘",
        "zuidixian": "아바타 설정",
        "bijieshou": "화신",
        "quezhi": "문제가 발생하여 도움이 필요한 경우 온라인 고객 서비스에 문의하세요.",
        "querenti": "이름",
        "yiwen": "금액을 입금하다",
        "tili": "입금액이 시스템 요구 사항을 충족하지 않습니다.",
        "yaohaoyou": "매장",
        "yaohuoci": "접속 이력",
        "yihanwei": "공식 보증",
        "gongxihuo": "공식적으로 제공됨"
    },
    "into_two": {
        "yibiaoban": "정기적인 재무관리",
        "nihao": "틀림없이",
        "yue": "감사 실패",
        "shebeigong": "시험 합격",
        "riqi": "고객 서비스",
        "gaishu": "고객 서비스",
        "kaicaizong": "회로망",
        "xiaoshili": "비밀번호 관리",
        "rili": "고객님, 자금의 보안을 위해 실명을 바인딩하고 출금 비밀번호를 설정해 주시기 바랍니다. 이름이 계좌 개설 이름과 일치하지 않으면 출금이 불가능합니다",
        "zhouli": "소수점은 반드시 입력해야 합니다.",
        "yeli": "시간이 지나면 시스템은 만료 후 자동으로 동결 해제됩니다.",
        "tuilian": "더 보려면 왼쪽이나 오른쪽으로 스와이프하세요.",
        "hezuo": "전송 된",
        "fukuanxin": "완전한",
        "tianjiadi": "취소됨",
        "gengxin": "이메일을 입력해주세요",
        "yibiaoti": "이미 계정이 있습니까?",
        "yaoqing": "이미 계정이 있습니다. 지금 다운로드하세요.",
        "yaoqingren": "만료됨",
        "shijian": "합격",
        "choujiangci": "해고됨",
        "choujianggai": "부를 향한 길을 시작하세요",
        "tuijianren": "계정 소유자",
        "xiejie": "계좌 개설 계약",
        "jiriqi": "계정 이름",
        "dianjifu": "계좌 개설 주소",
        "tishi": {
            "1": "계좌 개설 은행",
            "2": "예금은행",
            "3": "오늘의 수입"
        },
        "chongzhijin": "결제 대기 중",
        "chongzhigai": "보류 중",
        "nindeyu": "검토를 보류하다",
        "mianchong": "지불됩니다",
        "mianchongci": "영수증 대기 중",
        "chongzhili": {
            "title": "잠금 해제 예정",
            "jine": "WeChat에서 QR 코드를 직접 길게 누르면 식별할 수 있습니다.",
            "shijian": "비밀번호를 잊어버려",
            "zhauntai": "빠른 현금 인출"
        },
        "yijiangli": "총 충전",
        "yiqizhuan": "총 인출",
        "jianglili": "총 수익",
        "shezhi": "총 자산",
        "mimashe": "당신의 잔액",
        "dangqianmishu": "귀하의 주문은 다음 날짜에 이루어집니다.",
        "xinmi": "주문이 동결되었습니다 . 잠시만 기다려주세요.",
        "shuxinmi": "주문이 만료되어 처리할 수 없습니다.",
        "quemi": "귀하의 신원 정보",
        "shuquemi": "귀하의 은행 카드 정보",
        "dainyou": "이 주소를 삭제하시겠습니까?",
        "dianyoudi": "아직 은행 카드 정보를 추가하지 않았습니다.",
        "shudainyou": "\"서비스 계약\"에 동의했습니다.",
        "fukuanshe": "결제를 완료했어요",
        "bitedi": "나는 이해했고 동의했습니다.",
        "shugukuan": "내 잔액",
        "jisheng": "내 팀",
        "qiangou": "내 총 자산",
        "xiacixiaoshi": "내 휴대폰 번호",
        "yingjian": "내 주문",
        "zonggong": "내 지갑",
        "maidian": "내 직불카드",
        "yingjiancheng": "내 거",
        "zhuanzhang": "스크린샷 또는 직접",
        "dianfeizong": "은행",
        "zhuanzhangti": "모든 상품",
        "zhaunzhangfeiyong": "모든 유형",
        "zuidifei": "휴대폰번호가 틀렸어요",
        "tikuanjin": "휴대폰번호가 잘못 입력되었습니다.",
        "zuidixian": "전화 번호",
        "bijieshou": "전화 번호",
        "quezhi": "휴대폰",
        "querenti": "수수료",
        "yiwen": "주문을 받고",
        "tili": "주문접수시간",
        "yaohaoyou": "주문 번호",
        "yaohuoci": "주문접수기록",
        "yihanwei": "기록",
        "gongxihuo": "주문접수 안내"
    },
    "into_s1": {
        "yibiaoban": "주문을 받다",
        "nihao": "주문 수량",
        "yue": "주문 접수에 대한 수수료 리베이트",
        "shebeigong": "프로모션 포스터",
        "riqi": "권장인원",
        "gaishu": "추천상품",
        "kaicaizong": "추천하다",
        "xiaoshili": "제출 중",
        "rili": "제출이 완료되었습니다 . 검토를 기다려 주세요.",
        "zhouli": "제출이 완료되었습니다 . 곧 리디렉션됩니다.",
        "yeli": "주문을 제출",
        "tuilian": "제출하다",
        "hezuo": "인출 횟수",
        "fukuanxin": "출금현황",
        "tianjiadi": "탈퇴신청이 제출되었습니다",
        "gengxin": "출금기록",
        "yibiaoti": "출금률",
        "yaoqing": "출금금액",
        "yaoqingren": "출금한도",
        "shijian": "철회하다",
        "choujiangci": "찾다",
        "choujianggai": "결제수단",
        "tuijianren": "지점 주소",
        "xiejie": "받는 사람",
        "jiriqi": "수취인",
        "dianjifu": "소득 기준",
        "tishi": {
            "1": "혜택 유형",
            "2": "수익기록",
            "3": "수취인 이름"
        },
        "chongzhijin": "배송 주소 정보",
        "chongzhigai": "배송지 주소 수정",
        "nindeyu": "배송지 주소 수정",
        "mianchong": "배송 주소",
        "mianchongci": "신원 정보 수신",
        "chongzhili": {
            "title": "새로운 사람들",
            "jine": "새 비밀번호",
            "shijian": "새 휴대폰 번호",
            "zhauntai": "시간"
        },
        "yijiangli": "어제 팀 커미션",
        "yiqizhuan": "어제 수익",
        "jianglili": "데이터 없음",
        "shezhi": "아직 기록이 없습니다",
        "mimashe": "추가 정보",
        "dangqianmishu": "더",
        "xinmi": "은행 카드가 바인딩되어 있지 않습니다 . 바인딩하러 가세요.",
        "shuxinmi": "지역을 입력하지 않았습니다. 설정하세요.",
        "quemi": "계좌 개설 은행이 입력되지 않았습니다. 설정해주세요.",
        "shuquemi": "지점 주소가 입력되지 않았습니다. 설정해주세요.",
        "dainyou": "전화번호가 입력되지 않았습니다. 설정해 주세요.",
        "dianyoudi": "전화번호가 입력되지 않았습니다. 설정해 주세요.",
        "shudainyou": "실명이 입력되지 않았습니다. 설정해주세요.",
        "fukuanshe": "상세 주소가 입력되지 않았습니다. 설정해주세요.",
        "bitedi": "은행 카드 번호가 입력되지 않았습니다. 설정하세요.",
        "shugukuan": "가 입력되지 않았습니다 . 설정해주세요.",
        "jisheng": "이 데이터는 다음에서 제공됩니다.",
        "qiangou": "이 인출에는 처리 수수료가 공제됩니다.",
        "xiacixiaoshi": "로드 중",
        "yingjian": "매일 주문을 받을 수 있어요",
        "zonggong": "QR코드가 없습니다 . 클릭해주세요.",
        "maidian": "데이터 없음",
        "yingjiancheng": "더 이상 콘텐츠가 없습니다.",
        "zhuanzhang": "더 이상 데이터가 없습니다",
        "dianfeizong": "어떤 기록도 없다",
        "zhuanzhangti": "등록 시간",
        "zhaunzhangfeiyong": "등록하다",
        "zuidifei": "참고: 충전 정보가 많기 때문에 충전하기 전에 계정 카드 번호를 주의 깊게 확인하십시오. 이 플랫폼은 수시로 계정을 변경합니다. 궁금한 사항이 있는 경우 온라인 고객 서비스를 클릭하세요.",
        "tikuanjin": "활동 센터",
        "zuidixian": "활동적인 사람의 수",
        "bijieshou": "새 배송 주소",
        "quezhi": "친절한 팁",
        "querenti": "상태",
        "yiwen": "사용자 재충전",
        "tili": "사용자 이름은 비워둘 수 없습니다.",
        "yaohaoyou": "사용자 이름 입력 오류 입니다. 2~12자의 문자 또는 숫자가 필요합니다.",
        "yaohuoci": "사용자가 주문을 받습니다.",
        "yihanwei": "사용자 탈퇴",
        "gongxihuo": "전화 번호"
    },
    "into_f": {
        "yibiaoban": "로그인 비밀번호",
        "nihao": "로그인",
        "yue": "바로 아래",
        "shebeigong": "바로 아래",
        "riqi": "실제 이름",
        "gaishu": "수정 확인",
        "kaicaizong": "카드 바인딩 확인",
        "xiaoshili": "확신하는",
        "rili": "충전 확인",
        "zhouli": "취소를 확인하셨나요 ? 취소하면 금액이 동결됩니다.",
        "yeli": "비밀번호 확인",
        "tuilian": "이 금액을 잔액에서 인출하시겠습니까? 부당한 인출에 대해서는 이자가 계산되지 않습니다! , 공제",
        "hezuo": "종료하시겠습니까?",
        "fukuanxin": "몇 초 안에 내 페이지로 돌아갑니다.",
        "tianjiadi": "두번째",
        "gengxin": "즉시 철수",
        "yibiaoti": "지금 구매",
        "yaoqing": "즉시 업그레이드",
        "yaoqingren": "지금 설정하세요",
        "shijian": "구매자의 확인 대기 중",
        "choujiangci": "구매자 확인을 기다리는 중",
        "choujianggai": "판매자 시스템 응답을 기다리는 중",
        "tuijianren": "필터",
        "xiejie": "소개",
        "jiriqi": "시스템 알림",
        "dianjifu": "이 시스템은 LBS 기술을 기반으로 하며 클라우드를 통해 자동으로 상품을 매칭합니다.",
        "tishi": {
            "1": "시스템 계정",
            "2": "누적 수입",
            "3": "온라인 충전"
        },
        "chongzhijin": "오프라인 충전",
        "chongzhigai": "휴대폰 번호 바인딩",
        "nindeyu": "은행 카드 바인딩",
        "mianchong": "통계",
        "mianchongci": "배송지 주소 수정",
        "chongzhili": {
            "title": "직불카드 수정",
            "jine": "편집하다",
            "shijian": "네트워크가 불안정합니다 . 신호가 좋은 곳에서 다시 시도해 주세요.",
            "zhauntai": "네트워크가 불안정합니다 . 신호가 좋은 곳에서 다시 시도해 주세요."
        },
        "yijiangli": "연락처",
        "yiqizhuan": "가서 주문 받아",
        "jianglili": "자동적 인",
        "shezhi": "자동 계산",
        "mimashe": "자체 운영 쇼핑몰",
        "dangqianmishu": "에게",
        "xinmi": "인증 코드 받기",
        "shuxinmi": "규칙",
        "quemi": "터놓다",
        "shuquemi": "주문 번호",
        "dainyou": "주문이 동결되었으며 동결 해제 시간은 다음과 같습니다.",
        "dianyoudi": "주문 시간이 초과되었습니다.",
        "shudainyou": "총 주문 금액",
        "fukuanshe": "주문 합계",
        "bitedi": "주문 제출 중",
        "shugukuan": "주문이 성공적으로 제출되었습니다.",
        "jisheng": "주문 세부정보",
        "qiangou": "주문하다",
        "xiacixiaoshi": "비밀번호 기억하기",
        "yingjian": "공통 주소로 설정",
        "zonggong": "기본값으로 설정",
        "maidian": "아바타 설정",
        "yingjiancheng": "세부",
        "zhuanzhang": "주소",
        "dianfeizong": "결제 바우처를 업로드해주세요.",
        "zhuanzhangti": "충전 바우처를 업로드해주세요.",
        "zhaunzhangfeiyong": "결제정보를 잘 확인해주세요",
        "zuidifei": "지불 하십시요",
        "tikuanjin": "이름을 바꿔주세요",
        "zuidixian": "재충전 시간에 영향을 미치지 않도록 이체 금액을 소수점 이하 자리까지 유지해 주시기 바랍니다.",
        "bijieshou": "아래 계좌로 이체 후 충전해주세요",
        "quezhi": "충전 완료 후 온라인 고객센터에 문의해주세요.",
        "querenti": "충전 이름을 입력해주세요.",
        "yiwen": "충전휴대전화번호를 입력해주세요.",
        "tili": "충전금액을 입력해주세요.",
        "yaohaoyou": "이름을 입력해주세요",
        "yaohuoci": "휴대폰 번호를 입력해주세요",
        "yihanwei": "정확한 휴대폰번호를 입력해주세요",
        "gongxihuo": "자세한 주소를 입력해주세요"
    },
    "into_s": {
        "yibiaoban": "자세한 배송주소를 입력해주세요",
        "nihao": "비밀번호를 기억해 주세요 . 비밀번호를 잊어버린 경우 고객센터로 문의해 주세요.",
        "yue": "온라인 고객 서비스에 문의하세요 . (플랫폼은 수시로 계정을 변경합니다.)",
        "shebeigong": "거래 비밀번호를 입력해주세요",
        "riqi": "충전금액을 입력해주세요",
        "gaishu": "원래 비밀번호를 입력해주세요",
        "kaicaizong": "비밀번호를 입력 해주세요",
        "xiaoshili": "계좌 소유자의 이름을 입력하세요.",
        "rili": "계정 소유자의 휴대폰 번호를 입력하세요.",
        "zhouli": "계좌 개설 은행 주소를 입력하세요",
        "yeli": "계좌개설 은행을 입력해주세요",
        "tuilian": "계좌가 개설된 은행을 입력해주세요",
        "hezuo": "새로운 비밀번호를 입력해주세요",
        "fukuanxin": "전화번호를 입력해주세요",
        "tianjiadi": "휴대폰 인증번호를 입력해주세요",
        "gengxin": "추천코드를 입력해주세요",
        "yibiaoti": "출금금액을 입력해주세요",
        "yaoqing": "수취인의 이름을 입력해주세요",
        "yaoqingren": "새로운 비밀번호를 입력해주세요",
        "shijian": "휴대폰 번호나 이메일 주소를 입력해주세요",
        "choujiangci": "사용자 이름을 입력하세요",
        "choujianggai": "로그인 비밀번호를 입력해주세요",
        "tuijianren": "SMS 인증번호를 입력해주세요",
        "xiejie": "계정 /비밀번호를 입력해주세요",
        "jiriqi": "펀드 비밀번호를 입력해주세요",
        "dianjifu": "이체금액을 입력해주세요",
        "tishi": {
            "1": "초대코드를 입력해주세요",
            "2": "은행카드번호를 입력해주세요",
            "3": "인증번호를 입력해주세요"
        },
        "chongzhijin": "결제채널을 선택해주세요",
        "chongzhigai": "결제채널을 선택해주세요",
        "nindeyu": "배송주소를 선택해주세요",
        "mianchong": "업그레이드하려는 레벨을 선택하세요.",
        "mianchongci": "계정 잔액",
        "chongzhili": {
            "title": "계좌 동결 금액",
            "jine": "계정 세부정보",
            "shijian": "계좌 금액",
            "zhauntai": "구매 수익금"
        },
        "yijiangli": "실명을 입력하지 않고 구매하시려면 꼭 설정해주세요",
        "yiqizhuan": "금융상품 구매시 악의적 구매에 대한 수익은 계산되지 않으며, 수수료가 부과됩니다.",
        "jianglili": "구입하다",
        "shezhi": "펀드 비밀번호",
        "mimashe": "리디렉션 중",
        "dangqianmishu": "송금하려면 메시지를 복사한 후 온라인 뱅킹이나 알리페이로 이동하여 송금 및 충전을 완료하세요.",
        "xinmi": "충전금액을 입력하세요",
        "shuxinmi": "이름을 입력하시오",
        "quemi": "입금액을 입력하세요",
        "shuquemi": "휴대폰번호 입력",
        "dainyou": "펀드 비밀번호를 입력하세요",
        "dianyoudi": "돌아오는 중",
        "shudainyou": "반품",
        "fukuanshe": "아직 수확 주소가 추가되지 않았습니다.",
        "bitedi": "아직 추가된 은행 카드가 없습니다.",
        "shugukuan": "매장에 들어가서 구경해보세요",
        "jisheng": "원격 호스트가 할당 중입니다.",
        "qiangou": "로그아웃",
        "xiacixiaoshi": "충전 방법을 선택하세요",
        "yingjian": "출금방법을 선택하세요",
        "zonggong": "수량 선택",
        "maidian": "금융상품을 선택하세요",
        "yingjiancheng": "친구를 초대",
        "zhuanzhang": "가입하시면 더 많은 혜택을 받으실 수 있습니다",
        "dianfeizong": "초대 코드",
        "zhuanzhangti": "초대링크 : 복사하려면 클릭하세요.",
        "zhaunzhangfeiyong": "결제정보를 잘 확인해주세요",
        "zuidifei": "금융카드 현금인출",
        "tikuanjin": "직불카드 계좌",
        "zuidixian": "은행 카드",
        "bijieshou": "은행 이름",
        "quezhi": "질문",
        "querenti": "도움이 필요한 경우 고객 서비스에 문의하여 수동으로 충전할 수 있습니다.",
        "yiwen": "갚아야 해",
        "tili": "예상 수익",
        "yaohaoyou": "기대수익률",
        "yaohuoci": "첫 입금하는 사람 수",
        "yihanwei": "첫 장",
        "gongxihuo": "지금 재충전하세요"
    },
    "into_se": {
        "yibiaoban": "확인 코드",
        "nihao": "기본",
        "yue": "QR 코드를 스캔하려면 수동으로 앱의 스크린샷을 찍어 로컬에 저장하세요.",
        "shebeigong": "APP를 수동으로 사용해 주세요.",
        "riqi": "집",
        "gaishu": "비밀번호로그인",
        "kaicaizong": "아직 제출되지 않음",
        "xiaoshili": "등록 성공",
        "rili": "업그레이드 가능",
        "zhouli": "업그레이드할 수 없습니다",
        "yeli": "업그레이드 조건이 충족되지 않으면 업그레이드할 수 없습니다.",
        "tuilian": "업그레이드 기준에 도달하여 업그레이드를 완료했습니다.",
        "hezuo": "시스템 알림",
        "fukuanxin": "사용자 잔액 부족",
        "tianjiadi": "초대된 사용자가 충분하지 않습니다.",
        "gengxin": "업그레이드 조건이 충족되지 않습니다",
        "yibiaoti": "필요한 계좌 잔액이 다음보다 큽니다.",
        "yaoqing": "초대하다",
        "yaoqingren": "잠금을 해제하다",
        "shijian": "지갑 주소",
        "choujiangci": "송금 가능한 월렛 스캔",
        "choujianggai": "오늘 팀 커미션",
        "tuijianren": "앱 다운로드",
        "xiejie": "재충전 보너스",
        "jiriqi": "TRC20 주소를 입력해주세요",
        "dianjifu": "ERC20 주소를 입력해주세요",
        "tishi": {
            "1": "회사 소개",
            "2": "대리인",
            "3": "규칙"
        },
        "chongzhijin": "소개하다",
        "chongzhigai": "자격",
        "nindeyu": "선물 상자를 열면 깜짝 놀란다",
        "mianchong": "즉시 돈을 벌어보세요",
        "mianchongci": "기존 비밀번호",
        "chongzhili": {
            "title": "이전 비밀번호를 입력해주세요",
            "jine": "비밀번호를 다시 입력해주세요",
            "shijian": "비밀번호가 업데이트되었습니다",
            "zhauntai": "비밀번호를 변경하지 못했습니다."
        },
        "yijiangli": "계약에 동의하려면 확인란을 선택하세요.",
        "yiqizhuan": "업그레이드 기준에 도달하여 자동으로 업그레이드되었습니다.",
        "jianglili": "밸런스 변경으로 인해 다운그레이드되었습니다.",
        "shezhi": "시스템 알림",
        "mimashe": "거래 주문",
        "dangqianmishu": "시스템에 의해 결제가 강제로 이루어졌습니다. 궁금한 사항이 있으면 고객 서비스에 문의하세요.",
        "xinmi": "자동 주문 접수 켜기",
        "shuxinmi": "자동 주문 접수 끄기",
        "quemi": "중복된 사용자 이름",
        "shuquemi": "밸런스 변경으로 인해 다운그레이드되었습니다.",
        "dainyou": "업그레이드 기준에 도달하여 자동으로 업그레이드되었습니다.",
        "dianyoudi": "전화",
        "shudainyou": "회사 소개",
        "fukuanshe": "지금 보기",
        "bitedi": "플랫폼",
        "shugukuan": "발표",
        "jisheng": "친구를 초대하여 현금을 받으세요",
        "chongxindenglu": "다시 로그인해주세요",
        "pingtaijianjie": "플랫폼 소개",
        "pingtaijianjie1": "주문 잡기 규칙",
        "pingtaijianjie2": "대행사 협력",
        "pingtaijianjie3": "회사 자격"
    },
    "qing_sd": "기다리세요",
    "loading1": "온라인 프록시",
    "loading2": "주문 요청",
    "loading3": "주문을 받고",
    "goods": {
        "0": "녹색 유리",
        "1": "독점 스킨 케어 제품",
        "2": "식품 등급 플라스틱 컵",
        "3": "클래식 향수",
        "4": "수입 커피콩",
        "5": "디즈니 스타일 곰"
    },
    "tab_name": {
        "0": "첫 장",
        "1": "주문기록",
        "2": "주문",
        "3": "고객 서비스",
        "4": "내 거"
    },
    "pingjia": "평가하다",
    "login_t1": "전 세계에서 쇼핑하고 리베이트를 받을 수 있는 원스톱 상점",
    "zhangh": "휴대폰을 입력해주세요",
    "email": "이메일",
    "use_app": "앱 사용",
    "index_t1": "추가 30% 할인 + 10% 캐시백 + 첫 번째 앱 구매 시 무료 배송 이용약관이 적용됩니다.",
    "qianbao": "지갑",
    "huoqu_yj": "커미션 받기",
    "zhangh_ye": "계정 잔액",
    "zhangh_je": "계정 잔액",
    "huoq_yj": "커미션 받기",
    "dingd_s": "주문 수량",
    "caoz_bz": "단계",
    "caoz_t1": "1. 작업 시작 버튼을 클릭하고 프롬프트에 따라 작업을 완료합니다.",
    "caoz_t2": "2. 작업 완료 후 잔액만큼 수수료를 정산할 수 있습니다.",
    "kefu_t1": "질문이 있거나 도움이 필요하시면,",
    "kefu_t2": "문제를 해결하려면 온라인 고객 서비스에 문의하세요.",
    "kefu_t3": "귀하의 헌신적인 고객 서비스",
    "changj_wtjd": "자주 묻는 질문",
    "changj_wt": {
        "0": {
            "name": "충전방법과 결제수단은 무엇인가요 ?",
            "value": "이 시스템은 여러 국가에 개방되어 있으며 우리가 제공하는 국제 결제 방법에는 USDT(ERC20)가 포함됩니다. 동시에 우리는 다양한 국가의 국가 통화도 지원합니다."
        },
        "1": {
            "name": "어떻게 투자하고 수익을 얻을 수 있나요 ?",
            "value": "시스템 내에서 상품 거래에 참여하여 매일 안정적인 거래 수익을 얻을 수 있습니다. 모든 수입은 귀하의 은행 카드로 인출될 수 있습니다."
        },
        "2": {
            "name": "회원가입은 어떻게 하나요 ?",
            "value": "신규 회원 등록은 등록 회원의 수입을 보장하고, 과잉 등록으로 인한 수입 감소를 방지하기 위해 초대 시스템을 이용하고 있으며, 신규 회원은 기존 회원의 초대가 있어야만 등록할 수 있습니다."
        },
        "3": {
            "name": "구매금액에 제한이 있나요 ?",
            "value": "네, 더 많은 회원에게 수익 창출 기회를 제공하기 위해 시스템의 각 계정에는 최소 구매 한도가 있습니다."
        }
    },
    "yonghu_m": "사용자 이름",
    "shoukuan_zh": "미수금",
    "youxiang": "우편",
    "zhanghao": "계정",
    "xiugai_mima": "비밀번호 변경",
    "xuanze_yy": "언어를 선택하세요",
	queren:'확인하다',
	bangka:'결제계좌를 묶어주세요',
	xingy_d:'축하드립니다. 행운의 주문을 받으셨습니다.'
}